import {
  InteractionStepType,
  InteractionStepConfig,
  IndexedInteractionStepResponse,
  StepParamsForType,
  StepParamsForTypeWithStage,
} from '@scale/shared/types/chat';
import { IMultiTurnThreadHistory } from '../../ThreadHistory.interface';
import { ExperimentalToolUseConfigurationComponent } from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/ProcessSupervision/ExperimentalToolUseConfigurationComponent';
import { ReviewLevel } from '@scale/shared-types';
import _ from 'lodash';
import { isConditionallyVisible, isStepVisible } from '@scale/shared/chat/api';
import StepDescriptor from '../stepDescriptor/StepDescriptor';
import ExperimentalToolUseViewComponent from './ExperimentalToolUseViewComponent';
import ExperimentalToolUsePinnedViewComponent from './ExperimentalToolUsePinnedViewComponent';

import { schema } from './validation';

export class ExperimentalToolUseDescriptor extends StepDescriptor<InteractionStepType.ExperimentalToolUse> {
  type = InteractionStepType.ExperimentalToolUse;
  title = InteractionStepConfig[InteractionStepType.ExperimentalToolUse].title;
  description = InteractionStepConfig[InteractionStepType.ExperimentalToolUse].description;

  validationSchema = schema;

  ViewComponent = ExperimentalToolUseViewComponent; // Placeholder for actual TaskComponent
  PinnedViewComponent = ExperimentalToolUsePinnedViewComponent; // Placeholder for actual TaskComponent

  ConfigurationComponent = ExperimentalToolUseConfigurationComponent; // Placeholder for actual ConfigurationComponent

  isResponseValid(
    response: IndexedInteractionStepResponse,
    stepParams: StepParamsForTypeWithStage<InteractionStepType.ExperimentalToolUse>,
    history: IMultiTurnThreadHistory,
    reviewLevel?: ReviewLevel,
  ) {
    if (
      !isStepVisible(stepParams, reviewLevel) ||
      !isConditionallyVisible(
        stepParams,
        history.responses,
        response.index,
        history.threadParams.templateVariables,
        reviewLevel,
      )
    ) {
      return { canSubmit: true, submitTooltip: '' };
    }

    if (
      !response?.context?.chunks?.length ||
      _.every(
        response.context.chunks,
        chunk => _.isUndefined(chunk.content) || _.isUndefined(chunk.rating),
      )
    ) {
      return {
        canSubmit: false,
        submitTooltip: 'Some steps are missing ratings. Please rate all steps before submitting.',
      };
    }

    return { canSubmit: true, submitTooltip: '' };
  }

  getResponseTemplatePaths(
    _stepParams: StepParamsForType<InteractionStepType.ExperimentalToolUse>,
    _history: IMultiTurnThreadHistory,
  ) {
    // Implementation to get response template paths
    return [];
  }

  generateEmptyResponse(
    _stepParams: StepParamsForType<InteractionStepType.ExperimentalToolUse>,
    history: IMultiTurnThreadHistory,
  ) {
    // const emptyResponse = createDefaultResponseForFields(this.params.params.fields);
    const emptyResponse = {};
    return {
      type: InteractionStepType.ExperimentalToolUse,
      context: {
        shouldContinue: false,
        response: emptyResponse,
      },
      output: history.getMostRecentResponse(),
    };
  }

  getConfigurationPreviewTags() {
    // Generate configuration preview tags
    return [];
  }
}
